<!-- CTA de recarga. Uno solo para los cinco avisos de saldo (USDT, CLP×2,
     VES×2): el destino sale de `origen`, así que no hace falta parametrizarlo.
     Antes los avisos decían "recargá" sin decir dónde. -->
<ng-template #ctaRecarga>
  <button type="button" (click)="irARecargar()"
    style="width:100%; display:inline-flex; align-items:center; justify-content:center; gap:8px; min-height:42px; margin-top:10px; padding:10px 14px; background:#B7791F; color:#fff; border:none; border-radius:10px; font-weight:700; font-size:0.85rem; cursor:pointer; transition:background 0.2s ease;"
    onmouseover="this.style.background='#9C6516'" onmouseout="this.style.background='#B7791F'">
    <mat-icon style="font-size:18px;width:18px;height:18px;color:#fff;">account_balance_wallet</mat-icon>
    Recargar {{ origen }}
  </button>
</ng-template>

<div class="px-2 sm:px-4 md:px-8 py-6" style="max-width: 760px; margin: 0 auto;">

  <!-- Header -->
  <div class="mb-5 flex items-start justify-between gap-3 flex-wrap">
    <div>
      <h1 class="text-2xl font-bold text-gray-800 flex items-center">
        <mat-icon style="color: #1C593D; margin-right: 8px;">public</mat-icon>
        Enviar a otros países
      </h1>
      <p style="font-size: 0.82rem; color: #6b7280; margin-top: 4px;">
        Enviá a destinos internacionales · elegí con qué saldo pagar.
      </p>
    </div>
    <!-- Saldo disponible (según el origen elegido; oculto hasta elegir) -->
    <div *ngIf="origen && (esOrigenClp ? saldoClp !== null : esOrigenVes ? saldoVes !== null : saldoUsdt !== null)"
      style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border: 1px solid #bbf7d0; border-radius: 12px; padding: 8px 14px; text-align: right; flex-shrink: 0;">
      <div style="font-size: 0.62rem; color: #16794a; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px;">Saldo disponible</div>
      <div *ngIf="!esOrigenClp && !esOrigenVes" style="font-size: 1.05rem; font-weight: 800; color: #1e5a3f;">{{ saldoUsdt | number:'1.2-2' }} <span style="font-size: 0.7rem; font-weight: 700;">USDT</span></div>
      <div *ngIf="esOrigenClp" style="font-size: 1.05rem; font-weight: 800; color: #1e5a3f;">{{ saldoClp | number:'1.0-0' }} <span style="font-size: 0.7rem; font-weight: 700;">CLP</span></div>
      <div *ngIf="esOrigenVes" style="font-size: 1.05rem; font-weight: 800; color: #1e5a3f;">{{ saldoVes | number:'1.0-0' }} <span style="font-size: 0.7rem; font-weight: 700;">VES</span></div>
    </div>
  </div>

  <!-- Wizard progress -->
  <div class="flex items-center gap-2 mb-5" style="background: white; border-radius: 12px; padding: 10px 14px; border: 1px solid #e5e7eb;">
    <div class="step-pill" [class.active]="step === 'calc'" [class.done]="step !== 'calc'">
      <span class="num">1</span><span class="lbl">Cálculo</span>
    </div>
    <div class="connector" [class.done]="step !== 'calc'"></div>
    <div class="step-pill"
      [class.active]="step === 'beneficiary'"
      [class.done]="step === 'summary' || step === 'done'"
      [class.inactive]="step === 'calc'">
      <span class="num">2</span><span class="lbl">Beneficiario</span>
    </div>
    <div class="connector" [class.done]="step === 'summary' || step === 'done'"></div>
    <div class="step-pill" [class.active]="step === 'summary'" [class.done]="step === 'done'" [class.inactive]="step === 'calc' || step === 'beneficiary'">
      <span class="num">3</span><span class="lbl">Resumen</span>
    </div>
  </div>

  <!-- ============== PASO 1: CÁLCULO ============== -->
  <div *ngIf="step === 'calc'" class="bg-white rounded-2xl shadow-md border border-gray-100 p-5">

    <!-- Origen de fondos (dropdown con bandera; solo CL puede elegir CLP) -->
    <div *ngIf="origenes.length > 1" class="mb-4">
      <label class="field-label">¿Con qué saldo pagás?</label>
      <mat-form-field appearance="outline" class="vc-field w-full">
        <mat-select [ngModel]="origen" (ngModelChange)="selectOrigen($event)">
          <mat-select-trigger *ngIf="origen">
            <span style="display:inline-flex; align-items:center; gap:8px;">
              <img *ngIf="origen === 'CLP'" src="assets/flags/chile.png" alt=""
                style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
              <img *ngIf="origen === 'VES'" src="assets/flags/venezuela.png" alt=""
                style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
              <img *ngIf="origen === 'USDT'" src="assets/icons/USDT_Logo.png" alt=""
                style="width:20px;height:20px;border-radius:50%;object-fit:contain;" />
              {{ origen === 'CLP' ? 'Pesos Chilenos' : origen === 'VES' ? 'Bolívares' : 'USDT' }}
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let o of origenes" [value]="o">
            <span style="display:inline-flex; align-items:center; gap:8px;">
              <img *ngIf="o === 'CLP'" src="assets/flags/chile.png" alt=""
                style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
              <img *ngIf="o === 'VES'" src="assets/flags/venezuela.png" alt=""
                style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
              <img *ngIf="o === 'USDT'" src="assets/icons/USDT_Logo.png" alt=""
                style="width:20px;height:20px;border-radius:50%;object-fit:contain;" />
              {{ o === 'CLP' ? 'Pesos Chilenos' : o === 'VES' ? 'Bolívares' : 'USDT' }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Error países -->
    <div *ngIf="countriesError" style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 10px 14px; margin-bottom: 12px;">
      <span style="color: #b91c1c; font-weight: 600; font-size: 0.85rem;">{{ countriesError }}</span>
    </div>

    <div *ngIf="countriesLoading && origen === 'USDT'" class="flex justify-center py-6"><mat-spinner diameter="28"></mat-spinner></div>

    <ng-container *ngIf="!countriesLoading && origen === 'USDT'">
      <!-- País destino — dropdown con bandera -->
      <div class="mb-4">
        <label class="field-label">País destino</label>
        <mat-form-field appearance="outline" class="vc-field w-full">
          <mat-select [ngModel]="selectedCountryCode" (ngModelChange)="selectCountry($event)" placeholder="Elegí el país">
            <mat-select-trigger *ngIf="selectedCountry">
              <span style="display:inline-flex; align-items:center; gap:8px;">
                <img *ngIf="flagSrc(selectedCountry)" [src]="flagSrc(selectedCountry)" alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
                {{ selectedCountry.name }} <span style="color:#6b7280;">· {{ selectedCountry.currency }}</span>
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let c of countries" [value]="c.code">
              <span style="display:inline-flex; align-items:center; gap:8px;">
                <img *ngIf="flagSrc(c)" [src]="flagSrc(c)" alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
                <span *ngIf="!flagSrc(c) && c.flagIcon" style="font-size:18px;">{{ c.flagIcon }}</span>
                <mat-icon *ngIf="!flagSrc(c) && !c.flagIcon" style="font-size:18px;width:18px;height:18px;color:#9ca3af;">public</mat-icon>
                {{ c.name }} <span style="color:#6b7280;">· {{ c.currency }}</span>
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Variante / rail — botones con el plazo visible ANTES de confirmar (WS2.3) -->
      <div *ngIf="selectedCountryCode" class="mb-4">
        <label class="field-label">¿Cómo querés enviarlo?</label>
        <div *ngIf="variantsLoading" class="flex justify-start items-center gap-2 py-2">
          <mat-spinner diameter="16"></mat-spinner>
          <span style="font-size: 0.8rem; color: #6b7280;">Consultando opciones…</span>
        </div>
        <div *ngIf="variantsError" style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 8px 12px;">
          <span style="color: #b91c1c; font-size: 0.82rem;">{{ variantsError }}</span>
        </div>
        <div *ngIf="!variantsLoading && variants.length > 0" class="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <button *ngFor="let v of variants" type="button" (click)="selectVariant(v.code)"
            [style.border]="selectedVariantCode === v.code ? '2px solid #1C593D' : '1px solid #e5e7eb'"
            [style.background]="selectedVariantCode === v.code ? '#f0fdf4' : 'white'"
            style="display: flex; align-items: center; gap: 10px; min-height: 56px; padding: 10px 14px; border-radius: 12px; cursor: pointer; text-align: left; transition: all 0.15s ease;">
            <!-- Radio -->
            <span style="width: 18px; height: 18px; border-radius: 50%; flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center;"
              [style.border]="selectedVariantCode === v.code ? '2px solid #1C593D' : '2px solid #d1d5db'">
              <span *ngIf="selectedVariantCode === v.code" style="width: 9px; height: 9px; border-radius: 50%; background: #1C593D;"></span>
            </span>
            <span style="min-width: 0;">
              <span style="display: block; font-size: 0.88rem; font-weight: 700;"
                [style.color]="selectedVariantCode === v.code ? '#1e5a3f' : '#374151'">{{ v.label }}</span>
              <span style="display: inline-flex; align-items: center; gap: 4px; font-size: 0.72rem; font-weight: 600; margin-top: 2px;"
                [style.color]="v.businessDays <= 0 ? '#16a34a' : '#6b7280'">
                <mat-icon style="font-size: 13px; width: 13px; height: 13px;">{{ v.businessDays <= 0 ? 'bolt' : 'schedule' }}</mat-icon>
                {{ variantPlazoCorto(v) }}
              </span>
            </span>
          </button>
        </div>
      </div>

      <!-- Envías ↔ Reciben (estilo Vita: dos cajas + tasa al medio) -->
      <div *ngIf="selectedVariant" class="mb-3">
        <!-- Envías -->
        <div style="border:2px solid #d1d5db; border-radius:14px 14px 0 0; padding:12px 16px; background:white;">
          <div style="font-size:0.68rem; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.4px;">Envías</div>
          <div style="display:flex; align-items:center; gap:8px; margin-top:2px;">
            <!-- `type="text"` + appMonto: separador de miles visual. El modelo
                 sigue recibiendo number; `inputmode` conserva el teclado numérico. -->
            <input type="text" inputmode="numeric" appMonto
              [(ngModel)]="amountUsd" (ngModelChange)="onAmountChange()"
              style="flex:1; min-width:0; border:none; outline:none; font-size:1.4rem; font-weight:800; color:#1e5a3f; background:transparent;" />
            <span style="font-size:0.85rem; font-weight:700; color:#374151; background:#f3f4f6; border-radius:8px; padding:5px 12px; flex-shrink:0;">USDT</span>
          </div>
        </div>
        <!-- Divisor. La tasa y su desglose se muestran sobre "Continuar". -->
        <div style="display:flex; align-items:center; justify-content:center; padding:7px; background:#f0fdf4; border-left:2px solid #d1d5db; border-right:2px solid #d1d5db;">
          <mat-icon style="font-size:15px;width:15px;height:15px;color:#1C593D;">swap_vert</mat-icon>
        </div>
        <!-- Reciben -->
        <div style="border:2px solid #d1d5db; border-top:none; border-radius:0 0 14px 14px; padding:12px 16px; background:#f9fafb;">
          <div style="font-size:0.68rem; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.4px;">El destinatario recibe</div>
          <div style="display:flex; align-items:center; gap:8px; margin-top:2px;">
            <span style="flex:1; min-width:0; font-size:1.4rem; font-weight:800; color:#166534;">
              <ng-container *ngIf="amountUsd && displayDisponible && !estimateError">{{ displayRecibe | number:fmtRecibe }}</ng-container>
              <ng-container *ngIf="!(amountUsd && displayDisponible && !estimateError)">—</ng-container>
            </span>
            <span *ngIf="displayMoneda" style="font-size:0.85rem; font-weight:700; color:#374151; background:#f3f4f6; border-radius:8px; padding:5px 12px; flex-shrink:0;">{{ displayMoneda }}</span>
          </div>
        </div>
        <div style="font-size: 0.75rem; color: #6b7280; margin-top: 6px;">
          Monto mínimo: <b>{{ effectiveMinAmount | number:'1.0-0' }} USD</b>
          <span *ngIf="selectedVariant.minAmountUsd > 20" style="color: #f59e0b;">(mínimo para este destino)</span>
        </div>
      </div>

      <!-- Bajo el mínimo: se cotiza igual pero NO se puede enviar. -->
      <div *ngIf="montoBajoMinimo && !estimateError && !cotizando"
        style="background: #fffbeb; border: 1px solid #fde68a; border-radius: 12px; padding: 12px 14px; margin-top: 12px; color:#92400e; font-size:0.85rem; display:flex; align-items:flex-start; gap:8px;">
        <mat-icon style="font-size:20px;width:20px;height:20px;flex-shrink:0;">info</mat-icon>
        <span>
          El mínimo por envío es <b>{{ effectiveMinAmount | number:'1.0-0' }} USD</b>.
          Subí el monto para poder continuar.
        </span>
      </div>

      <!-- Monto sobre el máximo: se simula (si el backend cotiza) pero NO se
           puede enviar. Se muestra siempre que exceda, haya número o no. -->
      <div *ngIf="montoExcedeMaximo && !estimateError && !cotizando"
        style="background: #fffbeb; border: 1px solid #fde68a; border-radius: 12px; padding: 12px 14px; margin-top: 12px; color:#92400e; font-size:0.85rem; display:flex; align-items:flex-start; gap:8px;">
        <mat-icon style="font-size:20px;width:20px;height:20px;flex-shrink:0;">info</mat-icon>
        <span>
          El máximo por envío es <b>{{ maxUsd | number:'1.0-0' }} USD</b>.
          Bajá el monto para poder continuar.
        </span>
      </div>

      <!-- Saldo insuficiente: se puede simular pero NO avanzar al envío -->
      <div *ngIf="faltaSaldoUsdt && !montoExcedeMaximo && !estimateError && (esColombia ? cotizacion?.disponible === true : !!estimate)"
        style="background: #fffbeb; border: 1px solid #fde68a; border-radius: 12px; padding: 12px 14px; margin-top: 12px; color:#92400e; font-size:0.85rem;">
        <div style="display:flex; align-items:flex-start; gap:8px;">
          <mat-icon style="font-size:20px;width:20px;height:20px;flex-shrink:0;">account_balance_wallet</mat-icon>
          <span>
            Esto es una <b>simulación</b>. Tu saldo de
            <b>{{ saldoUsdt | number:'1.2-2' }} USDT</b>
            <ng-container *ngIf="saldoInsuficiente; else usdtBajoMinimo">
              no alcanza para enviar <b>{{ amountUsd | number:'1.2-2' }} USD</b>.
            </ng-container>
            <ng-template #usdtBajoMinimo>
              no llega al mínimo de este destino, <b>{{ minUsdVigente | number:'1.0-2' }} USD</b>.
            </ng-template>
            Recargá tu saldo para completar el envío.
          </span>
        </div>
        <ng-container *ngTemplateOutlet="ctaRecarga"></ng-container>
      </div>

      <!-- Colombia sin disponibilidad (margen / servicio) -->
      <div *ngIf="esColombia && cotizacion && cotizacion.disponible === false && !estimateError && !cotizando && !montoExcedeMaximo"
        style="background: #fef3c7; border: 1px solid #fde68a; border-radius: 10px; padding: 10px 14px; margin-top: 12px; color:#92400e; font-size:0.85rem;">
        Servicio no disponible en este momento, intentá más tarde.
      </div>

      <div *ngIf="calculandoUsdt" class="flex justify-center py-3"><mat-spinner diameter="22"></mat-spinner></div>

      <div *ngIf="estimateError"
        style="background: #fef3c7; border: 1px solid #fde68a; border-radius: 10px; padding: 10px 14px; margin-top: 12px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #f59e0b; vertical-align: middle;">warning</mat-icon>
        <span style="font-size: 0.82rem; font-weight: 600; color: #92400e; margin-left: 6px;">{{ estimateError }}</span>
      </div>

      <!-- Tasa + desglose de la cotización. Colapsado por defecto. -->
      <div *ngIf="selectedVariant" class="desglose">
        <button type="button" class="desglose-head" [class.is-open]="desgloseAbierto"
          [disabled]="!puedeDesplegarDesglose" (click)="desgloseAbierto = !desgloseAbierto">
          <mat-icon class="desglose-swap">swap_vert</mat-icon>
          <span class="desglose-tasa">
            <ng-container *ngIf="!amountUsd">Ingresá el monto a enviar</ng-container>
            <ng-container *ngIf="amountUsd && calculandoUsdt">calculando…</ng-container>
            <!-- USD→COP y USD→PEN: cabecera con la tasa de REFERENCIA (bruta,
                 la del rail). Resto de destinos: la efectiva (recibe ÷ envía). -->
            <ng-container *ngIf="amountUsd && !calculandoUsdt && displayDisponible && !estimateError">
              <ng-container *ngIf="tasaReferenciaEnCabecera; else tasaEfectiva">Tasa de referencia: 1 USD = {{ displayTasaReferencia | number:'1.2-2' }} {{ displayMoneda }} · {{ displayPlazo }}</ng-container>
              <ng-template #tasaEfectiva>1 USD ≈ {{ displayTasa | number:'1.0-2' }} {{ displayMoneda }} · {{ displayPlazo }}</ng-template>
            </ng-container>
            <ng-container *ngIf="amountUsd && !calculandoUsdt && (!displayDisponible || estimateError)">tasa no disponible</ng-container>
          </span>
          <span *ngIf="freshnessLabel && displayDisponible && !estimateError" class="freshness-badge"
            [ngClass]="'freshness-' + freshnessClass">{{ freshnessLabel }}</span>
          <mat-icon *ngIf="puedeDesplegarDesglose" class="desglose-chevron">expand_more</mat-icon>
        </button>

        <div *ngIf="desgloseAbierto && puedeDesplegarDesglose" class="desglose-body">
          <!-- En USD→COP y USD→PEN la tasa de referencia ya va en el encabezado. -->
          <div *ngIf="!tasaReferenciaEnCabecera" class="desglose-row">
            <span class="desglose-ico"><mat-icon>payments</mat-icon></span>
            <div class="desglose-lines">
              <div class="desglose-line">
                <span>Tasa de referencia</span>
                <b>1 USD = {{ displayTasaReferencia | number:'1.2-2' }} {{ displayMoneda }}</b>
              </div>
            </div>
          </div>

          <div class="desglose-row">
            <span class="desglose-ico"><mat-icon>arrow_forward</mat-icon></span>
            <div class="desglose-lines">
              <div class="desglose-line">
                <span>Monto a enviar</span>
                <b>{{ amountUsd | number:'1.2-2' }} USD</b>
              </div>
              <div class="desglose-line">
                <span>Comisión</span>
                <b>{{ displayComisionUsd | number:'1.2-2' }} USD</b>
              </div>
              <div class="desglose-line total">
                <span>Total a recibir</span>
                <b>{{ displayRecibe | number:fmtRecibe }} {{ displayMoneda }}</b>
              </div>
            </div>
          </div>

          <div class="desglose-row">
            <span class="desglose-ico"><mat-icon>schedule</mat-icon></span>
            <div class="desglose-lines">
              <div class="desglose-line">
                <span>Acreditación:</span>
                <b>{{ displayAcreditacion }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Continuar -->
      <button type="button" (click)="goToBeneficiary()" [disabled]="!puedeContinuar"
        [style.opacity]="puedeContinuar ? '1' : '0.5'"
        [style.cursor]="puedeContinuar ? 'pointer' : 'not-allowed'"
        style="display: inline-flex; align-items: center; gap: 8px; width: 100%; justify-content: center; margin-top: 18px; padding: 12px; background: #1C593D; color: white; border: none; border-radius: 12px; font-weight: 700; font-size: 0.95rem; transition: background 0.2s ease;"
        onmouseover="if(!this.disabled) this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        Continuar a beneficiario
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">arrow_forward</mat-icon>
      </button>
    </ng-container>

    <!-- ===== Calculadora CLP → COP (origen CLP; Colombia) ===== -->
    <ng-container *ngIf="origen === 'CLP'">
      <!-- País destino (CLP→COP: hoy solo Colombia) — dropdown con bandera -->
      <div class="mb-4">
        <label class="field-label">País destino</label>
        <mat-form-field appearance="outline" class="vc-field w-full">
          <mat-select [ngModel]="clpDestino" (ngModelChange)="selectClpPais($event)" placeholder="Elegí el país">
            <mat-select-trigger *ngIf="clpDestino === 'CO'">
              <span style="display:inline-flex; align-items:center; gap:8px;">
                <img src="assets/flags/colombia.png" alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
                Colombia <span style="color:#6b7280;">· COP</span>
              </span>
            </mat-select-trigger>
            <mat-select-trigger *ngIf="clpDestino === 'PE'">
              <span style="display:inline-flex; align-items:center; gap:8px;">
                <img src="assets/flags/peru.png" alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
                Perú <span style="color:#6b7280;">· PEN</span>
              </span>
            </mat-select-trigger>
            <mat-option value="CO">
              <span style="display:inline-flex; align-items:center; gap:8px;">
                <img src="assets/flags/colombia.png" alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
                Colombia <span style="color:#6b7280;">· COP</span>
              </span>
            </mat-option>
            <mat-option value="PE">
              <span style="display:inline-flex; align-items:center; gap:8px;">
                <img src="assets/flags/peru.png" alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
                Perú <span style="color:#6b7280;">· PEN</span>
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Entrega + monto + resultado: solo tras elegir país -->
      <!-- Desglose del flujo CLP (COP y PEN): tasa de REFERENCIA en la cabecera +
           comisión, mismo formato que el cotizador público. Sólo aparece si el
           backend mandó la referencia; el recibe es el del backend, acá no se
           recalcula nada. Definido una vez y usado por los dos destinos. -->
      <ng-template #desgloseClpTpl>
        <div *ngIf="puedeDesplegarDesgloseClp" class="desglose">
          <button type="button" class="desglose-head" [class.is-open]="desgloseClpAbierto"
            (click)="desgloseClpAbierto = !desgloseClpAbierto">
            <mat-icon class="desglose-swap">swap_vert</mat-icon>
            <span class="desglose-tasa">Tasa de referencia: 1 CLP = {{ tasaReferenciaClp | number:fmtRefClp }} {{ monedaDestinoClp }} · {{ plazoDestinoClp }}</span>
            <mat-icon class="desglose-chevron">expand_more</mat-icon>
          </button>

          <div *ngIf="desgloseClpAbierto" class="desglose-body">
            <div class="desglose-row">
              <span class="desglose-ico"><mat-icon>arrow_forward</mat-icon></span>
              <div class="desglose-lines">
                <div class="desglose-line">
                  <span>Monto a enviar</span>
                  <b>{{ montoClp | number:'1.0-0' }} CLP</b>
                </div>
                <div class="desglose-line">
                  <span>Comisión</span>
                  <b>{{ comisionClp | number:'1.0-0' }} CLP</b>
                </div>
                <div class="desglose-line total">
                  <span>Total a recibir</span>
                  <b>{{ recibeDestinoClp | number:fmtRecibeClp }} {{ monedaDestinoClp }}</b>
                </div>
              </div>
            </div>

            <div class="desglose-row">
              <span class="desglose-ico"><mat-icon>schedule</mat-icon></span>
              <div class="desglose-lines">
                <div class="desglose-line">
                  <span>Acreditación</span>
                  <b>{{ plazoDestinoClp }}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-container *ngIf="clpDestino === 'CO'">
      <!-- Forma de entrega -->
      <div class="mb-4">
        <label class="field-label">¿Cómo querés enviarlo?</label>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <button type="button" (click)="setRailClp('COBREB')"
            [style.border]="railClp === 'COBREB' ? '2px solid #1C593D' : '1px solid #e5e7eb'"
            [style.background]="railClp === 'COBREB' ? '#f0fdf4' : 'white'"
            style="display:flex; flex-direction:column; align-items:flex-start; min-height:56px; padding:10px 14px; border-radius:12px; cursor:pointer; text-align:left;">
            <span style="font-size:0.88rem; font-weight:700;" [style.color]="railClp === 'COBREB' ? '#1e5a3f' : '#374151'">Instantáneo (Bre-B)</span>
            <span style="font-size:0.72rem; font-weight:600; color:#16a34a;">menos de 1 hora</span>
          </button>
          <button type="button" (click)="setRailClp('CO')"
            [style.border]="railClp === 'CO' ? '2px solid #1C593D' : '1px solid #e5e7eb'"
            [style.background]="railClp === 'CO' ? '#f0fdf4' : 'white'"
            style="display:flex; flex-direction:column; align-items:flex-start; min-height:56px; padding:10px 14px; border-radius:12px; cursor:pointer; text-align:left;">
            <span style="font-size:0.88rem; font-weight:700;" [style.color]="railClp === 'CO' ? '#1e5a3f' : '#374151'">Transferencia bancaria</span>
            <span style="font-size:0.72rem; font-weight:600; color:#6b7280;">1 día hábil</span>
          </button>
        </div>
      </div>

      <!-- Envías ↔ Reciben (estilo Vita: dos cajas + tasa al medio) -->
      <div class="mb-3">
        <!-- Envías -->
        <div style="border:2px solid #d1d5db; border-radius:14px 14px 0 0; padding:12px 16px; background:white;">
          <div style="font-size:0.68rem; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.4px;">Envías</div>
          <div style="display:flex; align-items:center; gap:8px; margin-top:2px;">
            <input type="text" inputmode="numeric" appMonto
              [(ngModel)]="montoClp" (ngModelChange)="onMontoClpChange()"
              style="flex:1; min-width:0; border:none; outline:none; font-size:1.4rem; font-weight:800; color:#1e5a3f; background:transparent;" />
            <span style="font-size:0.85rem; font-weight:700; color:#374151; background:#f3f4f6; border-radius:8px; padding:5px 12px; flex-shrink:0;">CLP</span>
          </div>
        </div>
        <!-- Tasa al medio. Se OCULTA cuando hay tasa de referencia: en ese caso
             la tasa vive en el header del desplegable, igual que en USD→COP y
             USD→PEN, para no mostrar dos tasas distintas en la misma pantalla. -->
        <div *ngIf="tasaReferenciaClp == null"
          style="display:flex; align-items:center; justify-content:center; gap:6px; padding:7px; background:#f0fdf4; border-left:2px solid #d1d5db; border-right:2px solid #d1d5db;">
          <mat-icon style="font-size:15px;width:15px;height:15px;color:#1C593D;">swap_vert</mat-icon>
          <span style="font-size:0.76rem; color:#1C593D; font-weight:600;">
            <ng-container *ngIf="!montoClp">Ingresá el monto a enviar</ng-container>
            <ng-container *ngIf="montoClp && cotizandoClp">calculando…</ng-container>
            <ng-container *ngIf="montoClp && !cotizandoClp && cotizacionClp?.disponible === true">1 CLP ≈ {{ cotizacionClp?.tasaCopClp | number:'1.2-3' }} COP · {{ plazoClpLabel }}</ng-container>
            <ng-container *ngIf="montoClp && !cotizandoClp && cotizacionClp?.disponible !== true">tasa no disponible</ng-container>
          </span>
        </div>
        <!-- Reciben -->
        <div style="border:2px solid #d1d5db; border-top:none; border-radius:0 0 14px 14px; padding:12px 16px; background:#f9fafb;">
          <div style="font-size:0.68rem; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.4px;">El destinatario recibe</div>
          <div style="display:flex; align-items:center; gap:8px; margin-top:2px;">
            <span style="flex:1; min-width:0; font-size:1.4rem; font-weight:800; color:#166534;">
              <ng-container *ngIf="montoClp && cotizacionClp?.disponible === true">{{ cotizacionClp?.recibeCop | number:'1.0-0' }}</ng-container>
              <ng-container *ngIf="!(montoClp && cotizacionClp?.disponible === true)">—</ng-container>
            </span>
            <span style="font-size:0.85rem; font-weight:700; color:#374151; background:#f3f4f6; border-radius:8px; padding:5px 12px; flex-shrink:0;">COP</span>
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="desgloseClpTpl"></ng-container>

      <div *ngIf="cotizacionClp?.bajoMinimo"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:8px 12px; margin-bottom:6px; color:#92400e; font-size:0.8rem;">
        El mínimo por envío es <b>{{ cotizacionClp?.minClp | number:'1.0-0' }} CLP</b>. Subí el monto para poder enviar.
      </div>
      <div *ngIf="cotizacionClp?.excedeMaximo"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:8px 12px; margin-bottom:6px; color:#92400e; font-size:0.8rem;">
        El máximo por envío es <b>{{ cotizacionClp?.maxClp | number:'1.0-0' }} CLP</b>. Bajá el monto para poder enviar.
      </div>
      <div *ngIf="!cotizacionClp?.bajoMinimo && cotizacionClp?.minClp" style="font-size: 0.75rem; color: #6b7280; margin-bottom: 6px;">
        Monto mínimo: <b>{{ cotizacionClp?.minClp | number:'1.0-0' }} CLP</b>
      </div>

      <!-- No disponible -->
      <div *ngIf="!cotizandoClp && cotizacionClp && cotizacionClp.disponible === false"
        style="background: #fef3c7; border: 1px solid #fde68a; border-radius: 10px; padding: 10px 14px; margin-top: 4px; color:#92400e; font-size:0.85rem;">
        <ng-container *ngIf="cotizacionClp?.motivo === 'BAJO_MINIMO'">El monto mínimo es <b>{{ cotizacionClp.minClp | number:'1.0-0' }} CLP</b>.</ng-container>
        <ng-container *ngIf="cotizacionClp?.motivo !== 'BAJO_MINIMO'">Servicio no disponible en este momento, intentá más tarde.</ng-container>
      </div>

      <!-- Saldo CLP insuficiente: se cotiza pero no se puede enviar -->
      <div *ngIf="faltaSaldoClp && cotizacionClp?.disponible === true"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:10px 12px; margin-top:6px; color:#92400e; font-size:0.8rem;">
        <ng-container *ngIf="saldoClpInsuficiente; else clpBajoMinimo">
          No te alcanza el saldo CLP para este envío.
        </ng-container>
        <ng-template #clpBajoMinimo>
          Tu saldo CLP no llega al mínimo de este destino
          (<b>{{ minClpVigente | number:'1.0-0' }} CLP</b>).
        </ng-template>
        Tu disponible es <b>{{ saldoClp | number:'1.0-0' }} CLP</b>.
        <ng-container *ngTemplateOutlet="ctaRecarga"></ng-container>
      </div>

      <!-- Continuar (CLP→COP) -->
      <button type="button" (click)="goToBeneficiaryClp()" [disabled]="!puedeContinuarClp"
        [style.opacity]="puedeContinuarClp ? '1' : '0.5'"
        [style.cursor]="puedeContinuarClp ? 'pointer' : 'not-allowed'"
        style="width:100%; display:inline-flex; align-items:center; justify-content:center; gap:8px; min-height:48px; padding:12px; margin-top:14px; background:#1C593D; color:white; border:none; border-radius:10px; font-weight:700; font-size:0.9rem; transition:background 0.2s ease;"
        onmouseover="if(!this.disabled) this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size:18px;width:18px;height:18px;color:white;">arrow_forward</mat-icon>
        Continuar a beneficiario
      </button>
      </ng-container>

      <!-- ===== CLP → PEN (Perú): rail único instantáneo ===== -->
      <ng-container *ngIf="clpDestino === 'PE'">
      <div class="mb-3">
        <!-- Envías -->
        <div style="border:2px solid #d1d5db; border-radius:14px 14px 0 0; padding:12px 16px; background:white;">
          <div style="font-size:0.68rem; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.4px;">Envías</div>
          <div style="display:flex; align-items:center; gap:8px; margin-top:2px;">
            <input type="text" inputmode="numeric" appMonto
              [(ngModel)]="montoClp" (ngModelChange)="onMontoClpChange()"
              style="flex:1; min-width:0; border:none; outline:none; font-size:1.4rem; font-weight:800; color:#1e5a3f; background:transparent;" />
            <span style="font-size:0.85rem; font-weight:700; color:#374151; background:#f3f4f6; border-radius:8px; padding:5px 12px; flex-shrink:0;">CLP</span>
          </div>
        </div>
        <!-- Tasa al medio. Se OCULTA cuando hay tasa de referencia: ahí la tasa
             vive en el header del desplegable, igual que en CLP→COP y USD→COP. -->
        <div *ngIf="tasaReferenciaClp == null"
          style="display:flex; align-items:center; justify-content:center; gap:6px; padding:7px; background:#f0fdf4; border-left:2px solid #d1d5db; border-right:2px solid #d1d5db;">
          <mat-icon style="font-size:15px;width:15px;height:15px;color:#1C593D;">swap_vert</mat-icon>
          <span style="font-size:0.76rem; color:#1C593D; font-weight:600;">
            <ng-container *ngIf="!montoClp">Ingresá el monto a enviar</ng-container>
            <ng-container *ngIf="montoClp && cotizandoClp">calculando…</ng-container>
            <ng-container *ngIf="montoClp && !cotizandoClp && cotizacionClpPe?.disponible === true">1 CLP ≈ {{ cotizacionClpPe?.tasaPenClp | number:'1.4-6' }} PEN · menos de 1 hora</ng-container>
            <ng-container *ngIf="montoClp && !cotizandoClp && cotizacionClpPe?.disponible !== true">tasa no disponible</ng-container>
          </span>
        </div>
        <!-- Reciben -->
        <div style="border:2px solid #d1d5db; border-top:none; border-radius:0 0 14px 14px; padding:12px 16px; background:#f9fafb;">
          <div style="font-size:0.68rem; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.4px;">El destinatario recibe</div>
          <div style="display:flex; align-items:center; gap:8px; margin-top:2px;">
            <span style="flex:1; min-width:0; font-size:1.4rem; font-weight:800; color:#166534;">
              <ng-container *ngIf="montoClp && cotizacionClpPe?.disponible === true">{{ cotizacionClpPe?.recibePen | number:'1.2-2' }}</ng-container>
              <ng-container *ngIf="!(montoClp && cotizacionClpPe?.disponible === true)">—</ng-container>
            </span>
            <span style="font-size:0.85rem; font-weight:700; color:#374151; background:#f3f4f6; border-radius:8px; padding:5px 12px; flex-shrink:0;">PEN</span>
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="desgloseClpTpl"></ng-container>
      <div *ngIf="cotizacionClpPe?.bajoMinimo"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:8px 12px; margin-bottom:6px; color:#92400e; font-size:0.8rem;">
        El mínimo por envío es <b>{{ cotizacionClpPe?.minClp | number:'1.0-0' }} CLP</b>. Subí el monto para poder enviar.
      </div>
      <div *ngIf="cotizacionClpPe?.excedeMaximo"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:8px 12px; margin-bottom:6px; color:#92400e; font-size:0.8rem;">
        El máximo por envío es <b>{{ cotizacionClpPe?.maxClp | number:'1.0-0' }} CLP</b>. Bajá el monto para poder enviar.
      </div>
      <div *ngIf="!cotizacionClpPe?.bajoMinimo && cotizacionClpPe?.minClp" style="font-size: 0.75rem; color: #6b7280; margin-bottom: 6px;">
        Monto mínimo: <b>{{ cotizacionClpPe?.minClp | number:'1.0-0' }} CLP</b>
      </div>

      <!-- No disponible -->
      <div *ngIf="!cotizandoClp && cotizacionClpPe && cotizacionClpPe.disponible === false"
        style="background: #fef3c7; border: 1px solid #fde68a; border-radius: 10px; padding: 10px 14px; margin-top: 4px; color:#92400e; font-size:0.85rem;">
        Servicio no disponible en este momento, intentá más tarde.
      </div>

      <!-- Saldo CLP insuficiente -->
      <div *ngIf="faltaSaldoClp && cotizacionClpPe?.disponible === true"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:10px 12px; margin-top:6px; color:#92400e; font-size:0.8rem;">
        <ng-container *ngIf="saldoClpInsuficiente; else clpBajoMinimo">
          No te alcanza el saldo CLP para este envío.
        </ng-container>
        <ng-template #clpBajoMinimo>
          Tu saldo CLP no llega al mínimo de este destino
          (<b>{{ minClpVigente | number:'1.0-0' }} CLP</b>).
        </ng-template>
        Tu disponible es <b>{{ saldoClp | number:'1.0-0' }} CLP</b>.
        <ng-container *ngTemplateOutlet="ctaRecarga"></ng-container>
      </div>

      <!-- Continuar (CLP→PEN) -->
      <button type="button" (click)="goToBeneficiaryClp()" [disabled]="!puedeContinuarClp"
        [style.opacity]="puedeContinuarClp ? '1' : '0.5'"
        [style.cursor]="puedeContinuarClp ? 'pointer' : 'not-allowed'"
        style="width:100%; display:inline-flex; align-items:center; justify-content:center; gap:8px; min-height:48px; padding:12px; margin-top:14px; background:#1C593D; color:white; border:none; border-radius:10px; font-weight:700; font-size:0.9rem; transition:background 0.2s ease;"
        onmouseover="if(!this.disabled) this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size:18px;width:18px;height:18px;color:white;">arrow_forward</mat-icon>
        Continuar a beneficiario
      </button>
      </ng-container>
    </ng-container>

    <!-- ===== Calculadora VES → COP (origen VES; usuarios VE; espejo de CLP) ===== -->
    <ng-container *ngIf="origen === 'VES'">
      <!-- País destino (VES→COP: hoy solo Colombia) — dropdown con bandera -->
      <div class="mb-4">
        <label class="field-label">País destino</label>
        <mat-form-field appearance="outline" class="vc-field w-full">
          <mat-select [ngModel]="vesDestino" (ngModelChange)="selectVesPais($event)" placeholder="Elegí el país">
            <mat-select-trigger *ngIf="vesDestino === 'CO'">
              <span style="display:inline-flex; align-items:center; gap:8px;">
                <img src="assets/flags/colombia.png" alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
                Colombia <span style="color:#6b7280;">· COP</span>
              </span>
            </mat-select-trigger>
            <mat-select-trigger *ngIf="vesDestino === 'PE'">
              <span style="display:inline-flex; align-items:center; gap:8px;">
                <img src="assets/flags/peru.png" alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
                Perú <span style="color:#6b7280;">· PEN</span>
              </span>
            </mat-select-trigger>
            <mat-option value="CO">
              <span style="display:inline-flex; align-items:center; gap:8px;">
                <img src="assets/flags/colombia.png" alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
                Colombia <span style="color:#6b7280;">· COP</span>
              </span>
            </mat-option>
            <mat-option value="PE">
              <span style="display:inline-flex; align-items:center; gap:8px;">
                <img src="assets/flags/peru.png" alt=""
                  style="width:20px;height:20px;border-radius:50%;object-fit:cover;" />
                Perú <span style="color:#6b7280;">· PEN</span>
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Entrega + monto + resultado: solo tras elegir país -->
      <!-- Desglose del flujo VES (COP y PEN): tasa de REFERENCIA en la cabecera +
           comisión. Espejo del bloque CLP. La referencia la compone el backend
           contra NUESTRA tasa base porque el partner no cotiza VES; el recibe es
           el del backend, acá no se recalcula nada. Definido una vez, usado por
           los dos destinos. -->
      <ng-template #desgloseVesTpl>
        <div *ngIf="puedeDesplegarDesgloseVes" class="desglose">
          <button type="button" class="desglose-head" [class.is-open]="desgloseVesAbierto"
            (click)="desgloseVesAbierto = !desgloseVesAbierto">
            <mat-icon class="desglose-swap">swap_vert</mat-icon>
            <span class="desglose-tasa">Tasa de referencia: 1 VES = {{ tasaReferenciaVes | number:fmtRefVes }} {{ monedaDestinoVes }} · {{ plazoDestinoVes }}</span>
            <mat-icon class="desglose-chevron">expand_more</mat-icon>
          </button>

          <div *ngIf="desgloseVesAbierto" class="desglose-body">
            <div class="desglose-row">
              <span class="desglose-ico"><mat-icon>arrow_forward</mat-icon></span>
              <div class="desglose-lines">
                <div class="desglose-line">
                  <span>Monto a enviar</span>
                  <b>{{ montoVes | number:'1.0-0' }} VES</b>
                </div>
                <div class="desglose-line">
                  <span>Comisión</span>
                  <b>{{ comisionVes | number:'1.0-0' }} VES</b>
                </div>
                <div class="desglose-line total">
                  <span>Total a recibir</span>
                  <b>{{ recibeDestinoVes | number:fmtRecibeVes }} {{ monedaDestinoVes }}</b>
                </div>
              </div>
            </div>

            <div class="desglose-row">
              <span class="desglose-ico"><mat-icon>schedule</mat-icon></span>
              <div class="desglose-lines">
                <div class="desglose-line">
                  <span>Acreditación</span>
                  <b>{{ plazoDestinoVes }}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-container *ngIf="vesDestino === 'CO'">
      <!-- Forma de entrega -->
      <div class="mb-4">
        <label class="field-label">¿Cómo querés enviarlo?</label>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <button type="button" (click)="setRailVes('COBREB')"
            [style.border]="railVes === 'COBREB' ? '2px solid #1C593D' : '1px solid #e5e7eb'"
            [style.background]="railVes === 'COBREB' ? '#f0fdf4' : 'white'"
            style="display:flex; flex-direction:column; align-items:flex-start; min-height:56px; padding:10px 14px; border-radius:12px; cursor:pointer; text-align:left;">
            <span style="font-size:0.88rem; font-weight:700;" [style.color]="railVes === 'COBREB' ? '#1e5a3f' : '#374151'">Instantáneo (Bre-B)</span>
            <span style="font-size:0.72rem; font-weight:600; color:#16a34a;">menos de 1 hora</span>
          </button>
          <button type="button" (click)="setRailVes('CO')"
            [style.border]="railVes === 'CO' ? '2px solid #1C593D' : '1px solid #e5e7eb'"
            [style.background]="railVes === 'CO' ? '#f0fdf4' : 'white'"
            style="display:flex; flex-direction:column; align-items:flex-start; min-height:56px; padding:10px 14px; border-radius:12px; cursor:pointer; text-align:left;">
            <span style="font-size:0.88rem; font-weight:700;" [style.color]="railVes === 'CO' ? '#1e5a3f' : '#374151'">Transferencia bancaria</span>
            <span style="font-size:0.72rem; font-weight:600; color:#6b7280;">1 día hábil</span>
          </button>
        </div>
      </div>

      <!-- Envías ↔ Reciben (estilo Vita: dos cajas + tasa al medio) -->
      <div class="mb-3">
        <!-- Envías -->
        <div style="border:2px solid #d1d5db; border-radius:14px 14px 0 0; padding:12px 16px; background:white;">
          <div style="font-size:0.68rem; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.4px;">Envías</div>
          <div style="display:flex; align-items:center; gap:8px; margin-top:2px;">
            <input type="text" inputmode="numeric" appMonto
              [(ngModel)]="montoVes" (ngModelChange)="onMontoVesChange()"
              style="flex:1; min-width:0; border:none; outline:none; font-size:1.4rem; font-weight:800; color:#1e5a3f; background:transparent;" />
            <span style="font-size:0.85rem; font-weight:700; color:#374151; background:#f3f4f6; border-radius:8px; padding:5px 12px; flex-shrink:0;">VES</span>
          </div>
        </div>
        <!-- Tasa al medio. Se OCULTA cuando hay tasa de referencia: ahí la tasa
             vive en el header del desplegable, igual que en CLP y USD. -->
        <div *ngIf="tasaReferenciaVes == null"
          style="display:flex; align-items:center; justify-content:center; gap:6px; padding:7px; background:#f0fdf4; border-left:2px solid #d1d5db; border-right:2px solid #d1d5db;">
          <mat-icon style="font-size:15px;width:15px;height:15px;color:#1C593D;">swap_vert</mat-icon>
          <span style="font-size:0.76rem; color:#1C593D; font-weight:600;">
            <ng-container *ngIf="!montoVes">Ingresá el monto a enviar</ng-container>
            <ng-container *ngIf="montoVes && cotizandoVes">calculando…</ng-container>
            <ng-container *ngIf="montoVes && !cotizandoVes && cotizacionVes?.disponible === true">1 VES ≈ {{ cotizacionVes?.tasaCopVes | number:'1.2-4' }} COP · {{ plazoVesLabel }}</ng-container>
            <ng-container *ngIf="montoVes && !cotizandoVes && cotizacionVes?.disponible !== true">tasa no disponible</ng-container>
          </span>
        </div>
        <!-- Reciben -->
        <div style="border:2px solid #d1d5db; border-top:none; border-radius:0 0 14px 14px; padding:12px 16px; background:#f9fafb;">
          <div style="font-size:0.68rem; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.4px;">El destinatario recibe</div>
          <div style="display:flex; align-items:center; gap:8px; margin-top:2px;">
            <span style="flex:1; min-width:0; font-size:1.4rem; font-weight:800; color:#166534;">
              <ng-container *ngIf="montoVes && cotizacionVes?.disponible === true">{{ cotizacionVes?.recibeCop | number:'1.0-0' }}</ng-container>
              <ng-container *ngIf="!(montoVes && cotizacionVes?.disponible === true)">—</ng-container>
            </span>
            <span style="font-size:0.85rem; font-weight:700; color:#374151; background:#f3f4f6; border-radius:8px; padding:5px 12px; flex-shrink:0;">COP</span>
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="desgloseVesTpl"></ng-container>
      <div *ngIf="cotizacionVes?.bajoMinimo"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:8px 12px; margin-bottom:6px; color:#92400e; font-size:0.8rem;">
        El mínimo por envío es <b>{{ cotizacionVes?.minVes | number:'1.0-0' }} VES</b>. Subí el monto para poder enviar.
      </div>
      <div *ngIf="cotizacionVes?.excedeMaximo"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:8px 12px; margin-bottom:6px; color:#92400e; font-size:0.8rem;">
        El máximo por envío es <b>{{ cotizacionVes?.maxVes | number:'1.0-0' }} VES</b>. Bajá el monto para poder enviar.
      </div>
      <div *ngIf="!cotizacionVes?.bajoMinimo && cotizacionVes?.minVes" style="font-size: 0.75rem; color: #6b7280; margin-bottom: 6px;">
        Monto mínimo: <b>{{ cotizacionVes?.minVes | number:'1.0-0' }} VES</b>
      </div>

      <!-- No disponible -->
      <div *ngIf="!cotizandoVes && cotizacionVes && cotizacionVes.disponible === false"
        style="background: #fef3c7; border: 1px solid #fde68a; border-radius: 10px; padding: 10px 14px; margin-top: 4px; color:#92400e; font-size:0.85rem;">
        Servicio no disponible en este momento, intentá más tarde.
      </div>

      <!-- Saldo VES insuficiente: se cotiza pero no se puede enviar -->
      <div *ngIf="faltaSaldoVes && cotizacionVes?.disponible === true"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:10px 12px; margin-top:6px; color:#92400e; font-size:0.8rem;">
        <ng-container *ngIf="saldoVesInsuficiente; else vesBajoMinimo">
          No te alcanza el saldo VES para este envío.
        </ng-container>
        <ng-template #vesBajoMinimo>
          Tu saldo VES no llega al mínimo de este destino
          (<b>{{ minVesVigente | number:'1.0-0' }} VES</b>).
        </ng-template>
        Tu disponible es <b>{{ saldoVes | number:'1.0-0' }} VES</b>.
        <ng-container *ngTemplateOutlet="ctaRecarga"></ng-container>
      </div>

      <!-- Continuar (VES→COP) -->
      <button type="button" (click)="goToBeneficiaryVes()" [disabled]="!puedeContinuarVes"
        [style.opacity]="puedeContinuarVes ? '1' : '0.5'"
        [style.cursor]="puedeContinuarVes ? 'pointer' : 'not-allowed'"
        style="width:100%; display:inline-flex; align-items:center; justify-content:center; gap:8px; min-height:48px; padding:12px; margin-top:14px; background:#1C593D; color:white; border:none; border-radius:10px; font-weight:700; font-size:0.9rem; transition:background 0.2s ease;"
        onmouseover="if(!this.disabled) this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size:18px;width:18px;height:18px;color:white;">arrow_forward</mat-icon>
        Continuar a beneficiario
      </button>
      </ng-container>

      <!-- ===== VES → PEN (Perú): rail único instantáneo ===== -->
      <ng-container *ngIf="vesDestino === 'PE'">
      <!-- Envías ↔ Reciben (dos cajas + tasa al medio), moneda destino PEN -->
      <div class="mb-3">
        <!-- Envías -->
        <div style="border:2px solid #d1d5db; border-radius:14px 14px 0 0; padding:12px 16px; background:white;">
          <div style="font-size:0.68rem; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.4px;">Envías</div>
          <div style="display:flex; align-items:center; gap:8px; margin-top:2px;">
            <input type="text" inputmode="numeric" appMonto
              [(ngModel)]="montoVes" (ngModelChange)="onMontoVesChange()"
              style="flex:1; min-width:0; border:none; outline:none; font-size:1.4rem; font-weight:800; color:#1e5a3f; background:transparent;" />
            <span style="font-size:0.85rem; font-weight:700; color:#374151; background:#f3f4f6; border-radius:8px; padding:5px 12px; flex-shrink:0;">VES</span>
          </div>
        </div>
        <!-- Tasa al medio. Se OCULTA cuando hay tasa de referencia: ahí la tasa
             vive en el header del desplegable, igual que en CLP y USD. -->
        <div *ngIf="tasaReferenciaVes == null"
          style="display:flex; align-items:center; justify-content:center; gap:6px; padding:7px; background:#f0fdf4; border-left:2px solid #d1d5db; border-right:2px solid #d1d5db;">
          <mat-icon style="font-size:15px;width:15px;height:15px;color:#1C593D;">swap_vert</mat-icon>
          <span style="font-size:0.76rem; color:#1C593D; font-weight:600;">
            <ng-container *ngIf="!montoVes">Ingresá el monto a enviar</ng-container>
            <ng-container *ngIf="montoVes && cotizandoVes">calculando…</ng-container>
            <ng-container *ngIf="montoVes && !cotizandoVes && cotizacionVesPe?.disponible === true">1 VES ≈ {{ cotizacionVesPe?.tasaPenVes | number:'1.4-6' }} PEN · menos de 1 hora</ng-container>
            <ng-container *ngIf="montoVes && !cotizandoVes && cotizacionVesPe?.disponible !== true">tasa no disponible</ng-container>
          </span>
        </div>
        <!-- Reciben -->
        <div style="border:2px solid #d1d5db; border-top:none; border-radius:0 0 14px 14px; padding:12px 16px; background:#f9fafb;">
          <div style="font-size:0.68rem; font-weight:700; color:#6b7280; text-transform:uppercase; letter-spacing:0.4px;">El destinatario recibe</div>
          <div style="display:flex; align-items:center; gap:8px; margin-top:2px;">
            <span style="flex:1; min-width:0; font-size:1.4rem; font-weight:800; color:#166534;">
              <ng-container *ngIf="montoVes && cotizacionVesPe?.disponible === true">{{ cotizacionVesPe?.recibePen | number:'1.2-2' }}</ng-container>
              <ng-container *ngIf="!(montoVes && cotizacionVesPe?.disponible === true)">—</ng-container>
            </span>
            <span style="font-size:0.85rem; font-weight:700; color:#374151; background:#f3f4f6; border-radius:8px; padding:5px 12px; flex-shrink:0;">PEN</span>
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="desgloseVesTpl"></ng-container>
      <div *ngIf="cotizacionVesPe?.bajoMinimo"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:8px 12px; margin-bottom:6px; color:#92400e; font-size:0.8rem;">
        El mínimo por envío es <b>{{ cotizacionVesPe?.minVes | number:'1.0-0' }} VES</b>. Subí el monto para poder enviar.
      </div>
      <div *ngIf="cotizacionVesPe?.excedeMaximo"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:8px 12px; margin-bottom:6px; color:#92400e; font-size:0.8rem;">
        El máximo por envío es <b>{{ cotizacionVesPe?.maxVes | number:'1.0-0' }} VES</b>. Bajá el monto para poder enviar.
      </div>
      <div *ngIf="!cotizacionVesPe?.bajoMinimo && cotizacionVesPe?.minVes" style="font-size: 0.75rem; color: #6b7280; margin-bottom: 6px;">
        Monto mínimo: <b>{{ cotizacionVesPe?.minVes | number:'1.0-0' }} VES</b>
      </div>

      <!-- No disponible -->
      <div *ngIf="!cotizandoVes && cotizacionVesPe && cotizacionVesPe.disponible === false"
        style="background: #fef3c7; border: 1px solid #fde68a; border-radius: 10px; padding: 10px 14px; margin-top: 4px; color:#92400e; font-size:0.85rem;">
        Servicio no disponible en este momento, intentá más tarde.
      </div>

      <!-- Saldo VES insuficiente -->
      <div *ngIf="faltaSaldoVes && cotizacionVesPe?.disponible === true"
        style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:10px 12px; margin-top:6px; color:#92400e; font-size:0.8rem;">
        <ng-container *ngIf="saldoVesInsuficiente; else vesBajoMinimo">
          No te alcanza el saldo VES para este envío.
        </ng-container>
        <ng-template #vesBajoMinimo>
          Tu saldo VES no llega al mínimo de este destino
          (<b>{{ minVesVigente | number:'1.0-0' }} VES</b>).
        </ng-template>
        Tu disponible es <b>{{ saldoVes | number:'1.0-0' }} VES</b>.
        <ng-container *ngTemplateOutlet="ctaRecarga"></ng-container>
      </div>

      <!-- Continuar (VES→PEN) -->
      <button type="button" (click)="goToBeneficiaryVes()" [disabled]="!puedeContinuarVes"
        [style.opacity]="puedeContinuarVes ? '1' : '0.5'"
        [style.cursor]="puedeContinuarVes ? 'pointer' : 'not-allowed'"
        style="width:100%; display:inline-flex; align-items:center; justify-content:center; gap:8px; min-height:48px; padding:12px; margin-top:14px; background:#1C593D; color:white; border:none; border-radius:10px; font-weight:700; font-size:0.9rem; transition:background 0.2s ease;"
        onmouseover="if(!this.disabled) this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size:18px;width:18px;height:18px;color:white;">arrow_forward</mat-icon>
        Continuar a beneficiario
      </button>
      </ng-container>
    </ng-container>
  </div>

  <!-- ============== PASO 2: BENEFICIARIO DINÁMICO ============== -->
  <div *ngIf="step === 'beneficiary'" class="bg-white rounded-2xl shadow-md border border-gray-100 p-5">

    <div *ngIf="schemaLoading" class="flex justify-center py-8"><mat-spinner diameter="28"></mat-spinner></div>

    <div *ngIf="schemaError" style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 12px 16px;">
      <span style="color: #b91c1c; font-weight: 600;">{{ schemaError }}</span>
    </div>

    <ng-container *ngIf="schema && !schemaLoading">
      <!-- Header + botón Agregar a la derecha -->
      <div class="flex items-center justify-between mb-2">
        <div>
          <div class="flex items-center gap-2">
            <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">contacts</mat-icon>
            <span style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f;">
              Elegir beneficiario
            </span>
          </div>
          <p style="font-size: 0.76rem; color: #6b7280; margin: 4px 0 0;">
            Destinatarios guardados para <b>{{ selectedCountry?.name || selectedCountryCode }}</b>.
          </p>
        </div>
        <button type="button" (click)="openAddBeneficiarioDialog()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 14px; background: white; color: #1C593D; border: 2px dashed #34d399; border-radius: 12px; font-weight: 700; font-size: 0.82rem; cursor: pointer; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">add</mat-icon>
          Agregar
        </button>
      </div>

      <!-- Buscador (sticky) + scroll -->
      <div *ngIf="beneficiarios.length > 3" style="position: sticky; top: 0; background: white; z-index: 1; padding: 12px 0 8px;">
        <input type="text" [(ngModel)]="searchTxt" placeholder="Buscar por nombre, banco o documento…"
          style="width: 100%; padding: 10px 14px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.85rem; outline: none; box-sizing: border-box;"
          onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'" />
      </div>

      <!-- Spinner -->
      <div *ngIf="beneficiariosLoading" class="flex justify-center py-6">
        <mat-spinner diameter="26"></mat-spinner>
      </div>

      <!-- Error listando -->
      <div *ngIf="beneficiariosError" style="background: #fef3c7; border: 1px solid #fde68a; border-radius: 10px; padding: 10px 12px; margin: 10px 0;">
        <span style="color: #92400e; font-size: 0.8rem; font-weight: 600;">{{ beneficiariosError }}</span>
      </div>

      <!-- Estado vacío -->
      <div *ngIf="!beneficiariosLoading && !beneficiariosError && beneficiarios.length === 0"
        style="background: #f9fafb; border: 2px dashed #e5e7eb; border-radius: 12px; padding: 24px; text-align: center; margin: 14px 0;">
        <mat-icon style="color: #9ca3af; font-size: 36px; width: 36px; height: 36px;">person_off</mat-icon>
        <p style="font-size: 0.85rem; color: #374151; font-weight: 600; margin: 8px 0 4px;">
          No tenés beneficiarios guardados en {{ selectedCountry?.name || selectedCountryCode }}.
        </p>
        <p style="font-size: 0.76rem; color: #6b7280; margin: 0;">
          Tocá <b>Agregar</b> para registrar el primero.
        </p>
      </div>

      <!-- Empty filter -->
      <div *ngIf="!beneficiariosLoading && beneficiarios.length > 0 && filteredBeneficiarios.length === 0"
        style="background: #fffbeb; border: 1px dashed #fde68a; border-radius: 10px; padding: 14px; text-align: center; margin: 10px 0;">
        <span style="color: #92400e; font-size: 0.82rem; font-weight: 600;">
          Ningún beneficiario coincide con "<i>{{ searchTxt }}</i>".
        </span>
      </div>

      <!-- Lista de cards (scroll interno) -->
      <div *ngIf="!beneficiariosLoading && filteredBeneficiarios.length > 0"
        style="display: flex; flex-direction: column; gap: 8px; margin: 10px 0 16px; max-height: 420px; overflow-y: auto;">
        <div *ngFor="let b of filteredBeneficiarios"
          (click)="selectBeneficiario(b)"
          [style.border]="selectedBeneficiarioId === b.id ? '2px solid #1C593D' : '1px solid #e5e7eb'"
          [style.background]="selectedBeneficiarioId === b.id ? '#f0fdf4' : 'white'"
          [style.opacity]="b.vitaEstado === 'banned' ? '0.6' : '1'"
          [style.cursor]="b.vitaEstado === 'banned' ? 'not-allowed' : 'pointer'"
          style="border-radius: 12px; padding: 12px 14px; transition: all 0.15s ease;">
          <div class="flex items-center gap-3">
            <!-- Radio -->
            <div style="width: 20px; height: 20px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center;"
              [style.border]="selectedBeneficiarioId === b.id ? '2px solid #1C593D' : '2px solid #d1d5db'">
              <div *ngIf="selectedBeneficiarioId === b.id"
                style="width: 10px; height: 10px; border-radius: 50%; background: #1C593D;"></div>
            </div>
            <!-- Contenido -->
            <div style="flex: 1; min-width: 0;">
              <div style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">
                {{ displayNombre(b) }}
              </div>
              <div style="font-size: 0.76rem; color: #6b7280; margin-top: 3px; display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
                <span>{{ displayBanco(b) }} · {{ displayCuentaMask(b) }}</span>
                <span *ngIf="displayModalidad(b)"
                  style="background: #eef2ff; color: #4338ca; font-size: 0.62rem; font-weight: 700; padding: 2px 7px; border-radius: 999px; text-transform: uppercase; letter-spacing: 0.02em;">
                  {{ displayModalidad(b) }}
                </span>
              </div>
              <div style="font-size: 0.7rem; color: #9ca3af; margin-top: 2px;">
                {{ b.tipoId }} {{ b.numeroId }}<span *ngIf="b.email"> · {{ b.email }}</span>
              </div>
            </div>
            <!-- Badge + botón detalle -->
            <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 6px; flex-shrink: 0;">
              <span *ngIf="b.vitaEstado === 'ok'"
                style="background: #dcfce7; color: #166534; font-size: 0.62rem; font-weight: 700; padding: 3px 8px; border-radius: 999px;">
                VALIDADO
              </span>
              <span *ngIf="b.vitaEstado === 'banned'"
                style="background: #fee2e2; color: #991b1b; font-size: 0.62rem; font-weight: 700; padding: 3px 8px; border-radius: 999px;">
                BLOQUEADO
              </span>
              <button type="button" (click)="openDetail(b, $event)"
                title="Ver detalle y validar"
                style="display: inline-flex; align-items: center; gap: 4px; padding: 4px 10px; background: white; color: #1C593D; border: 1px solid #d1fae5; border-radius: 8px; font-weight: 600; font-size: 0.7rem; cursor: pointer;"
                onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
                <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #1C593D;">visibility</mat-icon>
                Ver
              </button>
              <button type="button" (click)="openEditBeneficiarioDialog(b, $event)"
                title="Editar datos"
                style="display: inline-flex; align-items: center; gap: 4px; padding: 4px 10px; background: white; color: #b45309; border: 1px solid #fde68a; border-radius: 8px; font-weight: 600; font-size: 0.7rem; cursor: pointer;"
                onmouseover="this.style.background='#fffbeb'" onmouseout="this.style.background='white'">
                <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #b45309;">edit</mat-icon>
                Editar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Bloqueo → operador de Aguacate: beneficiario no habilitado o con
           datos incompletos. El cliente no completa nada por su cuenta. -->
      <div *ngIf="bloqueoOperador" style="margin-top: 14px; padding: 14px 16px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 12px; color:#b91c1c; font-size:0.85rem; display:flex; align-items:flex-start; gap:8px;">
        <mat-icon style="font-size:20px;width:20px;height:20px;">support_agent</mat-icon>
        <span>{{ bloqueoOperador }}</span>
      </div>

      <!-- Footer acciones -->
      <div class="flex gap-2 mt-5">
        <button type="button" (click)="backToCalc()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">arrow_back</mat-icon>
          Volver
        </button>
        <button type="button" (click)="goToSummary()"
          [disabled]="!selectedBeneficiarioId"
          [style.opacity]="!selectedBeneficiarioId ? '0.5' : '1'"
          [style.cursor]="!selectedBeneficiarioId ? 'not-allowed' : 'pointer'"
          style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 12px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; transition: background 0.2s ease;"
          onmouseover="if(!this.disabled) this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          Continuar al resumen
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">arrow_forward</mat-icon>
        </button>
      </div>
    </ng-container>
  </div>

  <!-- ============== PASO 3: RESUMEN ============== -->
  <div *ngIf="step === 'summary' && (estimate || esColombia || esPeru) && schema" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 18px 22px; border-bottom: 2px solid #bbf7d0;">
      <div class="flex items-center gap-2">
        <mat-icon style="color: #1C593D;">receipt_long</mat-icon>
        <span style="font-size: 1rem; font-weight: 700; color: #1e5a3f;">Resumen del envío</span>
      </div>
      <p style="font-size: 0.72rem; color: #6b7280; margin-top: 4px;">
        Revisá los datos antes de confirmar.
      </p>
    </div>

    <div class="p-5">
      <!-- Bloque envío -->
      <div class="summary-block">
        <span class="summary-title">Envío</span>
        <div class="summary-row"><span>Monto enviado</span><b>
          <ng-container *ngIf="esVesFlow">{{ montoVes | number:'1.0-0' }} VES</ng-container>
          <ng-container *ngIf="esClpFlow">{{ montoClp | number:'1.0-0' }} CLP</ng-container>
          <ng-container *ngIf="!esClpFlow && !esVesFlow">{{ amountUsd | number:'1.2-2' }} USD</ng-container>
        </b></div>
        <div class="summary-row"><span>Destino</span><b>{{ estimate?.variantLabel || selectedVariant?.label || selectedVariantCode }}</b></div>
        <div class="summary-row"><span>Tasa</span><b>{{ displayTasa | number:fmtTasa }}</b></div>
        <div class="summary-row"><span>Acreditación</span><b>{{ displayPlazo }}</b></div>
        <div class="summary-row highlight">
          <span>Destinatario recibe</span>
          <b style="font-size: 1.15rem; color: #166534;">
            {{ displayRecibe | number:fmtRecibe }} {{ displayMoneda }}
          </b>
        </div>
      </div>

      <!-- Bloque beneficiario -->
      <div class="summary-block" style="margin-top: 14px;">
        <span class="summary-title">
          Beneficiario
          <span *ngIf="selectedBeneficiarioId" style="background: #dcfce7; color: #166534; font-size: 0.6rem; font-weight: 700; padding: 2px 8px; border-radius: 999px; margin-left: 6px; vertical-align: middle;">
            GUARDADO
          </span>
        </span>
        <div *ngFor="let f of visibleSchemaFields" class="summary-row">
          <span>{{ f.name }}</span>
          <b>{{ labelForValue(f, formValues[f.key]) || '—' }}</b>
        </div>
      </div>

      <!-- Aviso: la tasa cambió entre el preview y el confirm (valores ya ajustados) -->
      <div *ngIf="valoresCambiaron && !envioResult && !envioResultPe" style="margin-top: 16px; padding: 14px 16px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 12px; color:#92400e; font-size:0.85rem; display:flex; align-items:flex-start; gap:8px;">
        <mat-icon style="font-size:20px;width:20px;height:20px;">update</mat-icon>
        <span>La tasa se actualizó. Ahora el destinatario recibe <b>{{ displayRecibe | number:fmtRecibe }} {{ displayMoneda }}</b>. Revisá y confirmá nuevamente.</span>
      </div>

      <!-- Bloqueo → operador de Aguacate: datos incompletos (emisor o
           beneficiario) o beneficiario no habilitado. Sin autoservicio. -->
      <div *ngIf="bloqueoOperador" style="margin-top: 16px; padding: 14px 16px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 12px; color:#b91c1c; font-size:0.85rem; display:flex; align-items:flex-start; gap:8px;">
        <mat-icon style="font-size:20px;width:20px;height:20px;">support_agent</mat-icon>
        <span>{{ bloqueoOperador }}</span>
      </div>

      <!-- Error del envío (resto: mensajes directos del backend) -->
      <div *ngIf="envioError" style="margin-top: 16px; padding: 14px 16px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 12px; color:#b91c1c; font-size:0.85rem; display:flex; align-items:flex-start; gap:8px;">
        <mat-icon style="font-size:20px;width:20px;height:20px;">error_outline</mat-icon>
        <span>{{ envioError }}</span>
      </div>

      <!-- Acciones -->
      <div class="flex gap-2 mt-5 flex-wrap">
        <button type="button" (click)="backToBeneficiary()" [disabled]="enviando"
          [style.opacity]="enviando ? 0.5 : 1"
          style="display: inline-flex; align-items: center; gap: 6px; min-height: 44px; padding: 10px 18px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">arrow_back</mat-icon>
          Atrás
        </button>

        <!-- Colombia → envío productivo real. Disabled + spinner mientras viaja (WS2.1). -->
        <button type="button" (click)="confirmarRemesaActual()"
          *ngIf="esColombia || esPeru" [disabled]="enviando"
          [style.opacity]="enviando ? 0.7 : 1"
          [style.cursor]="enviando ? 'wait' : 'pointer'"
          style="flex: 1; min-width: 200px; display: inline-flex; align-items: center; justify-content: center; gap: 8px; min-height: 48px; padding: 12px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; transition: background 0.2s ease;"
          onmouseover="if(!this.disabled) this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-spinner *ngIf="enviando" diameter="18" class="spinner-en-boton"></mat-spinner>
          <mat-icon *ngIf="!enviando" style="font-size: 18px; width: 18px; height: 18px; color: white;">send</mat-icon>
          {{ enviando ? 'Enviando…' : 'Confirmar y enviar' }}
        </button>

        <!-- No-CO/PE (demo sin envío real) → reiniciar -->
        <button type="button" (click)="restart()"
          *ngIf="!esColombia && !esPeru"
          style="flex: 1; min-width: 200px; display: inline-flex; align-items: center; justify-content: center; gap: 8px; min-height: 48px; padding: 12px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">refresh</mat-icon>
          Nuevo envío
        </button>
      </div>
    </div>
  </div>

  <!-- ============== PASO 4: RESULTADO (pantalla propia — NO vuelve al form relleno) ============== -->
  <div *ngIf="step === 'done' && (envioResult || envioResultClp || envioResultClpPe || envioResultVes || envioResultVesPe || envioResultPe)" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 26px 22px; border-bottom: 2px solid #bbf7d0; text-align: center;">
      <div style="width: 64px; height: 64px; border-radius: 50%; background: #dcfce7; display: inline-flex; align-items: center; justify-content: center;">
        <mat-icon style="font-size: 36px; width: 36px; height: 36px; color: #16a34a;">check_circle</mat-icon>
      </div>
      <h2 style="font-size: 1.15rem; font-weight: 800; color: #1e5a3f; margin: 12px 0 2px;">¡Envío en proceso!</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">
        Operación <b class="font-mono">#{{ (envioResultVesPe || envioResultClpPe || envioResultVes || envioResultClp || envioResult || envioResultPe)?.txId }}</b> · te avisaremos cuando se complete.
      </p>
    </div>

    <div class="p-5">
      <div class="summary-block">
        <span class="summary-title">Detalle</span>
        <div class="summary-row"><span>Enviaste</span><b>
          <ng-container *ngIf="esVesFlow">{{ (envioResultVesPe?.montoVes ?? envioResultVes?.montoVes) | number:'1.0-0' }} VES</ng-container>
          <ng-container *ngIf="esClpFlow">{{ (envioResultClpPe?.montoClp ?? envioResultClp?.montoClp) | number:'1.0-0' }} CLP</ng-container>
          <ng-container *ngIf="!esClpFlow && !esVesFlow">{{ (envioResultPe?.montoUsd ?? envioResult?.montoUsd) | number:'1.2-2' }} USD</ng-container>
        </b></div>
        <div class="summary-row"><span>Beneficiario</span><b>{{ selectedBeneficiario ? displayNombre(selectedBeneficiario) : '—' }}</b></div>
        <div class="summary-row"><span>Acreditación estimada</span><b>{{ displayPlazo }}</b></div>
        <div class="summary-row highlight">
          <span>Recibirá</span>
          <b *ngIf="esVesPeFlow" style="font-size: 1.15rem; color: #166534;">{{ envioResultVesPe?.recibePen | number:fmtRecibe }} {{ displayMoneda }}</b>
          <b *ngIf="!esVesPeFlow && esClpPeFlow" style="font-size: 1.15rem; color: #166534;">{{ envioResultClpPe?.recibePen | number:fmtRecibe }} {{ displayMoneda }}</b>
          <b *ngIf="!esVesPeFlow && !esClpPeFlow && esPeru" style="font-size: 1.15rem; color: #166534;">{{ envioResultPe?.recibePen | number:fmtRecibe }} {{ displayMoneda }}</b>
          <b *ngIf="!esVesPeFlow && !esClpPeFlow && !esPeru" style="font-size: 1.15rem; color: #166534;">{{ (esVesFlow ? envioResultVes?.recibeCop : esClpFlow ? envioResultClp?.recibeCop : envioResult?.recibeCop) | number:'1.0-0' }} {{ displayMoneda }}</b>
        </div>
      </div>

      <div *ngIf="esVesFlow && saldoVes !== null" style="margin-top: 12px; font-size: 0.78rem; color: #6b7280; text-align: center;">
        Tu saldo disponible ahora es <b style="color:#1e5a3f;">{{ saldoVes | number:'1.0-0' }} VES</b>.
      </div>
      <div *ngIf="esClpFlow && saldoClp !== null" style="margin-top: 12px; font-size: 0.78rem; color: #6b7280; text-align: center;">
        Tu saldo disponible ahora es <b style="color:#1e5a3f;">{{ saldoClp | number:'1.0-0' }} CLP</b>.
      </div>
      <div *ngIf="!esClpFlow && !esVesFlow && saldoUsdt !== null" style="margin-top: 12px; font-size: 0.78rem; color: #6b7280; text-align: center;">
        Tu saldo disponible ahora es <b style="color:#1e5a3f;">{{ saldoUsdt | number:'1.2-2' }} USDT</b>.
      </div>

      <div class="flex gap-2 mt-5 flex-wrap">
        <a routerLink="/wallet/home"
          style="flex: 1; min-width: 160px; display: inline-flex; align-items: center; justify-content: center; gap: 6px; min-height: 48px; padding: 12px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; text-decoration: none;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">home</mat-icon>
          Ir al inicio
        </a>
        <button type="button" (click)="restart()"
          style="flex: 1; min-width: 160px; display: inline-flex; align-items: center; justify-content: center; gap: 8px; min-height: 48px; padding: 12px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
          Nuevo envío
        </button>
      </div>
    </div>
  </div>

</div>
